import Phaser from "phaser"
import { calculateScaleFactor } from "../config/scaling"
import {
	createTopBar,
	destroyIndicator,
	displayTooltip,
	destroyTooltip,
	updateMiniLevel,
	playUISound,
} from "../helpers/levelManager"
import { checkLocalSavedData } from "../helpers/levelManager"
import { saveEmailsOpenedLocally } from "../helpers/levelManager"
import {
	handleGameProgressUpdate,
	displayIndicator,
} from "../helpers/levelManager"
export default class EmailScene extends Phaser.Scene {
	constructor() {
		super({ key: "Emails" })
	}

	init() {
		// Game dimensions and scaling
		this.gameW = this.cameras.main.width
		this.gameH = this.cameras.main.height

		// Get scaling information
		let scalingData = calculateScaleFactor(this)
		this.scaleFactor = scalingData.scaleFactor
		this.safeZoneX = scalingData.safeZoneX
		this.safeZoneY = scalingData.safeZoneY
		this.safeZoneWidth = scalingData.safeZoneWidth
		this.safeZoneHeight = scalingData.safeZoneHeight
		this.templateY = scalingData.templateY

		// Responsive font sizing
		this.baseFontSize = 20
		this.fontSize = this.baseFontSize * this.scaleFactor

		this.emailsAndAlerts = this.cache.json.get("emailsAndAlerts")
		this.emails = this.emailsAndAlerts.emails
		console.log(this.emails)

		this.loadSavedData()
	}

	loadSavedData() {
		this.savedUserData = checkLocalSavedData()
		this.savedLevel = this.savedUserData?.userLevel || 0
		this.savedMiniLevel = this.savedUserData?.userMiniLevel || 0
		this.alertsOpened = this.savedUserData?.alertsOpened || 0
		this.emailsOpened = this.savedUserData?.emailsOpened || 0
		this.currentPlanet = this.savedUserData?.currentPlanet || 0
		console.log(
			"MiniLevel: " +
			this.savedMiniLevel +
			" emails opened: " +
			this.emailsOpened,
		)
	}

	create() {
		this.soundManager = this.scene.get("GameUI").soundManager
		createTopBar(this)
		this.emailBG = this.add
			.image(this.gameW / 2, this.gameH / 2, "tabletBG")
			.setScale(this.scaleFactor, this.scaleFactor * 1.08)

		this.appBar = this.add
			.image(
				this.gameW / 2,
				this.gameH / 2 - 125 * this.scaleFactor,
				"emailAppBar",
			)
			.setScale(this.scaleFactor)
			.setDepth(5)

		this.appBarText = this.add
			.text(this.appBar.x, this.appBar.y, "Email", {
				fontFamily: "Gluten",
				fontSize: this.fontSize + 4 * this.scaleFactor,
				color: "white",
				align: "left",
				fontStyle: "bold",
				resolution: 2,
			})
			.setOrigin(0.5)
			.setDepth(5)

		this.emailGroup = this.add.group()
		this.emailContentGroup = this.add.group()

		let closeButton = this.add
			.image(
				this.appBar.x + 230 * this.scaleFactor,
				this.appBar.y,
				"appCloseButton",
			)
			.setDepth(10).setScale(this.scaleFactor * 0.5)

		closeButton.setInteractive().on("pointerdown", () => {
			playUISound(this, this.soundManager, "Subtle click 1", 0.25)
			this.scene.stop("Emails")
			this.scene.resume("TabletScene")

		})

		// Create email list
		this.createEmailList()

		this.emailGroup.add(closeButton)
	}

	createEmailList() {
		// Clear any existing email list elements first
		this.emailGroup.clear(true, true)

		let closeButton = this.add
			.image(
				this.appBar.x + 230 * this.scaleFactor,
				this.appBar.y,
				"appCloseButton",
			)
			.setDepth(10).setScale(this.scaleFactor * 0.5)

		closeButton.setInteractive().on("pointerdown", () => {
			playUISound(this, this.soundManager, "Subtle click 1", 0.25)
			this.scene.stop("Emails")
			this.scene.resume("TabletScene")
		})

		this.emailGroup.add(closeButton)

		// Calculate spacing
		let emailSeparatorSpacing =
			(this.emailBG.height - 60 * this.scaleFactor) / this.emails.length
		let availableEmailsLength = this.emails.length

		if (this.currentPlanet === 1) {
			if (this.savedMiniLevel >= 4 && this.savedMiniLevel <= 12) {
				availableEmailsLength = 1
			}
			if (this.savedMiniLevel >= 11) {
				let facialScanOpened = this.alertsOpened["facialScan"]
				console.log("Facial Scan Opened: " + facialScanOpened)
				if (facialScanOpened) {
					availableEmailsLength = 2
				}
			}
		}

		if (this.currentPlanet === 2) {
			availableEmailsLength = 2
		}

		if (this.currentPlanet === 3) {
			if (this.savedMiniLevel >= 1 && this.savedMiniLevel <= 15) {
				availableEmailsLength = 3
			}
			if (this.savedMiniLevel >= 16) {
				availableEmailsLength = 4
			}
		}

		for (let i = availableEmailsLength - 1; i >= 0; i--) {
			// Calculate the display position (in reverse order)
			let displayIndex = availableEmailsLength - 1 - i
			let email = this.emails[i]

			// Determine email read status based on saved data
			let emailIconType = "readEmail"
			let fontStyle = "normal"
			console.log(
				"Email Index: " + email.index + " Emails Opened: " + this.emailsOpened,
			)
			if (this.emailsOpened < email.index) {
				emailIconType = "unreadEmail"
				fontStyle = "bold"
			}

			let emailHitBox = this.add
				.rectangle(
					this.emailBG.x,
					this.emailBG.y -
					(46 + 30 * this.scaleFactor) +
					displayIndex * emailSeparatorSpacing * this.scaleFactor,
					480 * this.scaleFactor,
					40 * this.scaleFactor,
					0xffffff,
				)
				.setInteractive()
				.setAlpha(0.01)

			let emailIcon = this.add.image(
				this.emailBG.x - 230 * this.scaleFactor,
				this.emailBG.y -
				(46 + 30 * this.scaleFactor) +
				displayIndex * emailSeparatorSpacing * this.scaleFactor,
				emailIconType,
			)

			let emailTitle = this.add.text(
				this.emailBG.x - 215 * this.scaleFactor,
				this.emailBG.y -
				(55 + 30 * this.scaleFactor) +
				displayIndex * emailSeparatorSpacing * this.scaleFactor,
				email.subject,
				{
					fontFamily: "Space Grotesk",
					fontSize: this.fontSize - 6 * this.scaleFactor,
					color: "#11044E",
					align: "left",
					fontStyle: fontStyle,
					resolution: 2,
				},
			)

			if (this.currentPlanet === 1 && this.savedMiniLevel === 4) {
				displayIndicator(
					this,
					this.gameW / 2,
					emailTitle.y + 5 * this.scaleFactor,
					0.9,
					"ultraWideIndicator",
				)
			}
			// Visual feedback on hover
			emailTitle
				.setInteractive({ useHandCursor: true })
				.on("pointerover", () => emailTitle.setTint(0xaaaaaa))
				.on("pointerout", () => emailTitle.clearTint())
				.on("pointerdown", () => {
					console.log(`Opening email ${email.index}`)
					this.openEmail(email)
					playUISound(this, this.soundManager, "Subtle click 1", 0.25)
				})

			emailIcon
				.setInteractive({ useHandCursor: true })
				.on("pointerover", () => emailIcon.setTint(0xaaaaaa))
				.on("pointerout", () => emailIcon.clearTint())
				.on("pointerdown", () => {
					console.log(`Opening email ${email.index}`)
					this.openEmail(email)
					playUISound(this, this.soundManager, "Subtle click 1", 0.25)
				})

			emailHitBox.on("pointerdown", () => {
				console.log(`Opening email ${email.index}`)
				this.openEmail(email)
				playUISound(this, this.soundManager, "Subtle click 1", 0.25)
			})

			let emailSeparator = this.add
				.image(
					this.emailBG.x,
					emailTitle.y + 30 * this.scaleFactor,
					"emailSeparator",
				)
				.setScale(0.85 * this.scaleFactor, 3 * this.scaleFactor)

			this.emailGroup.add(emailHitBox)
			this.emailGroup.add(emailIcon)
			this.emailGroup.add(emailTitle)
			this.emailGroup.add(emailSeparator)
		}
	}

	openEmail(email) {
		destroyIndicator(this)
		this.loadSavedData()

		let tabletScene = this.scene.get("TabletScene")
		if (tabletScene.notificationBell) {
			tabletScene.notificationBell.destroy()
		}
		if (tabletScene.tutorialHand) {
			tabletScene.tutorialHand.destroy()
		}

		tabletScene.removeUnlockAnim()

		if (this.currentPlanet === 1) {
			if (this.savedMiniLevel === 4) {
				console.log("Email Opened and Definitely Read")
				let cockpitScene = this.scene.get("CockpitScene")
				updateMiniLevel(this.savedMiniLevel)
				handleGameProgressUpdate(cockpitScene)
			}

			if (this.savedMiniLevel === 13) {
				console.log("Email Opened and Definitely Read")
				let cockpitScene = this.scene.get("CockpitScene")
				handleGameProgressUpdate(cockpitScene)
			}
		}

		// If the user is opening an email that is newer than the last one they opened,
		// update the saved email opened state
		if (this.emailsOpened < email.index) {
			this.emailsOpened = email.index
			console.log(
				"Opening email " + email.index + " emails opened: " + this.emailsOpened,
			)

			saveEmailsOpenedLocally(this.emailsOpened)
		}

		// Hide the email list
		this.emailGroup.setVisible(false)

		// Clear any existing email content
		this.emailContentGroup.clear(true, true)

		// Back button
		let backButton = this.add
			.image(
				this.appBar.x - 230 * this.scaleFactor,
				this.appBar.y,
				"appBackButton",
			)
			.setDepth(10)
			.setScale(this.scaleFactor * 0.5)

		backButton
			.setInteractive({ useHandCursor: true })
			.on("pointerover", () => backButton.setTint(0xaaaaaa))
			.on("pointerout", () => backButton.clearTint())
			.on("pointerdown", () => {
				// Clean up any event listeners
				this.input.off("pointerdown")
				this.input.off("pointermove")
				this.input.off("pointerup")

				this.emailContentGroup.clear(true, true)
				this.emailContentGroup.setVisible(false)

				// Refresh the email list to update read/unread status
				this.createEmailList()
				this.emailGroup.setVisible(true)
				playUISound(this, this.soundManager, "Subtle click 1", 0.25)
			})

		// Email subject header
		let subjectText = this.add.text(
			this.emailBG.x - 230 * this.scaleFactor,
			this.emailBG.y - 100 * this.scaleFactor,
			"Subject: " + email.subject,
			{
				fontFamily: "Space Grotesk",
				fontSize: this.fontSize - 3 * this.scaleFactor,
				color: "#11044E",
				align: "left",
				wordWrap: { width: 200 * this.scaleFactor, useAdvancedWrap: true },
				fontStyle: "bold",
				resolution: 2,
			},
		)

		let emailSafetyStatus = this.add
			.image(
				subjectText.x + 340 * this.scaleFactor,
				subjectText.y + 25 * this.scaleFactor,
				"safeEmailPill",
			)
			.setScale(0.5 * this.scaleFactor)

		// Add a separator between subject and body
		let emailSeparator = this.add
			.image(
				this.emailBG.x,
				subjectText.y + 50 * this.scaleFactor,
				"emailSeparator",
			)
			.setScale(0.85 * this.scaleFactor, 1.5 * this.scaleFactor)

		// Define the scrollable area
		const scrollStartY = subjectText.y + 50 * this.scaleFactor
		const scrollEndY = this.emailBG.y + 150 * this.scaleFactor
		const scrollHeight = scrollEndY - scrollStartY + 12 * this.scaleFactor
		const scrollWidth = 460 * this.scaleFactor

		// Special handling for email with index 3 that contains a clickable link
		if (email.index === 3) {
			// Create BBCodeText for the body, but handle the link specially
			const linkText = "link"
			//const linkText2 = "link (verified as safe)"
			const bodyTextContent = email.body

			const linkIndex = bodyTextContent.indexOf(linkText)

			if (linkIndex !== -1) {
				// Split the content around the link
				const textBefore = bodyTextContent.substring(0, linkIndex)
				const textAfter = bodyTextContent.substring(linkIndex + linkText.length)

				// Create the body text without the link word using BBCodeText
				const maskedContent = textBefore + "    " + textAfter // Spaces where link should be

				let bodyText = this.add.rexBBCodeText(
					this.emailBG.x - 230 * this.scaleFactor,
					scrollStartY + 10 * this.scaleFactor,
					maskedContent,
					{
						fontFamily: "Space Grotesk",
						fontSize: this.fontSize - 4 * this.scaleFactor,
						color: "#11044E",
						align: "left",
						wrap: {
							mode: "word",
							width: 460 * this.scaleFactor,
						},
						lineSpacing: 6,
						resolution: 2,
					},
				)

				// Calculate link position using a temporary BBCodeText object
				const tempText = this.add.rexBBCodeText(0, 0, textBefore, {
					fontFamily: "Space Grotesk",
					fontSize: this.fontSize - 4 * this.scaleFactor,
					wrap: {
						mode: "word",
						width: 460 * this.scaleFactor,
					},
					lineSpacing: 6,
				})

				tempText.addImage("miniNotificationBell", {
					key: "miniNotificationBell",
					width: 25 * this.scaleFactor,
					marginTop: 2 * this.scaleFactor,
				})
				tempText.addImage("alertIcon", {
					key: "alertIcon",
					width: this.scaleFactor * 25,
					marginTop: -2 * this.scaleFactor,
				})

				// Get wrapped text to calculate position
				const lines = tempText.getWrappedText()
				const lastLine = lines[lines.length - 1] || ""

				// Create temporary text to measure last line width
				const lastLineText = this.add.rexBBCodeText(0, 0, lastLine, {
					fontFamily: "Space Grotesk",
					fontSize: this.fontSize - 4 * this.scaleFactor,
				})
				const lastLineWidth = lastLineText.width
				lastLineText.destroy()

				// Calculate position for the link
				const lineHeight = tempText.height / Math.max(1, lines.length)
				const linkX = bodyText.x + lastLineWidth

				const isMobile =
					/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
						navigator.userAgent,
					)

				let linkY
				if (!isMobile) {
					linkY =
						bodyText.y + lineHeight * (lines.length - 1) + 2 * this.scaleFactor
				} else {
					linkY =
						bodyText.y + lineHeight * (lines.length - 1) + 5 * this.scaleFactor
				}

				// Clean up temporary text
				tempText.destroy()

				let newLinkText = linkText + " (verified as safe)"
				//let newLinkText = linkText

				// Create a clickable text object for "link"
				const linkTextObj = this.add.text(linkX, linkY, newLinkText, {
					fontFamily: "Space Grotesk",
					fontSize: this.fontSize - 4 * this.scaleFactor,
					color: "#5C58EB",
					fontStyle: "bold",
					resolution: 2,
				})

				displayTooltip(this, {
					xPos: linkX + 260 * this.scaleFactor,
					yPos: linkY + 12,
					type: "barcodeMatchTip",
					scale: 1,
					text: "Click the link to\nstart the reconnection\nprocess",
					fontScale: -7,
					xTextOffset: 3,
					yTextOffset: 1,
					wrapWidth: 1.8,
				})

				// Add underline
				const underline = this.add.graphics()
				underline.lineStyle(1, 0x5c58eb, 1)
				underline.beginPath()
				underline.moveTo(linkTextObj.x, linkTextObj.y + 2 * this.scaleFactor)
				underline.lineTo(
					linkTextObj.x + linkTextObj.width,
					linkTextObj.y + linkTextObj.height,
				)
				underline.closePath()
				underline.strokePath()

				// Make the link interactive
				linkTextObj
					.setInteractive({ useHandCursor: true })
					.on("pointerover", () => {
						linkTextObj.setTint(0x8888ff)
						underline.clear()
						underline.lineStyle(1, 0x8888ff, 1)
						underline.beginPath()
						underline.moveTo(linkTextObj.x, linkTextObj.y + linkTextObj.height)
						underline.lineTo(
							linkTextObj.x + linkTextObj.width,
							linkTextObj.y + linkTextObj.height,
						)
						underline.closePath()
						underline.strokePath()
					})
					.on("pointerout", () => {
						linkTextObj.clearTint()
						underline.clear()
						underline.lineStyle(1, 0x0000ff, 1)
						underline.beginPath()
						underline.moveTo(linkTextObj.x, linkTextObj.y + linkTextObj.height)
						underline.lineTo(
							linkTextObj.x + linkTextObj.width,
							linkTextObj.y + linkTextObj.height,
						)
						underline.closePath()
						underline.strokePath()
					})
					.on("pointerdown", () => {
						console.log("Link clicked!")
						// Redirect to Alerts app
						this.scene.stop("Emails")
						this.scene.start("Alerts")
						playUISound(this, this.soundManager, "Subtle click 1", 0.25)
					})

				// Create mask and scrolling functionality
				this.setupScrollingAndMask(
					bodyText,
					linkTextObj,
					underline,
					scrollStartY,
					scrollHeight,
					scrollEndY,
				)

				// Add elements to email content group
				this.emailContentGroup.add(bodyText)
				this.emailContentGroup.add(linkTextObj)
				this.emailContentGroup.add(underline)
				this.emailContentGroup.add(this.tooltip)
				this.emailContentGroup.add(this.tooltipText)

				this.time.delayedCall(10, () => {
					underline.clear()
					underline.lineStyle(1, 0x0000ff, 1)
					underline.beginPath()
					underline.moveTo(linkTextObj.x, linkTextObj.y + linkTextObj.height)
					underline.lineTo(
						linkTextObj.x + linkTextObj.width,
						linkTextObj.y + linkTextObj.height,
					)
					underline.closePath()
					underline.strokePath()
				})
			}
		}
		// Special handling for email with index 4 that contains a clickable authentication link
		else if (email.index === 4) {
			const linkText = "authentication link"
			const bodyTextContent = email.body
			const linkIndex = bodyTextContent.indexOf(linkText)

			if (linkIndex !== -1) {
				// Split the content around the link
				const textBefore = bodyTextContent.substring(0, linkIndex)
				const textAfter = bodyTextContent.substring(linkIndex + linkText.length)

				// Create the body text without the link word using BBCodeText
				const maskedContent = textBefore + "\n" + textAfter // Line break + spaces where link should be

				let bodyText = this.add.rexBBCodeText(
					this.emailBG.x - 230 * this.scaleFactor,
					scrollStartY + 10 * this.scaleFactor,
					maskedContent,
					{
						fontFamily: "Space Grotesk",
						fontSize: this.fontSize - 6 * this.scaleFactor,
						color: "#11044E",
						align: "left",
						wrap: {
							mode: "word",
							width: 460 * this.scaleFactor,
						},
						lineSpacing: 6,
						resolution: 2,
					},
				)

				// Calculate link position using a temporary BBCodeText object
				const tempText = this.add.rexBBCodeText(0, 0, textBefore + "", {
					fontFamily: "Space Grotesk",
					fontSize: this.fontSize - 6 * this.scaleFactor,
					color: "#11044E",
					wrap: {
						mode: "word",
						width: 460 * this.scaleFactor,
					},
					lineSpacing: 6,
				})

				// tempText.addImage("alertIcon", {
				// 	key: "alertIcon",
				// 	width: this.scaleFactor * 25,
				// 	marginTop: -2 * this.scaleFactor,
				// })
				// tempText.addImage("notificationBell", {
				// 	key: "notificationBell",
				// 	width: this.scaleFactor * 25,
				// 	marginTop: 2 * this.scaleFactor,
				// })

				// Get wrapped text to calculate position
				const lines = tempText.getWrappedText()
				const lastLine = lines[lines.length - 1] || ""

				// Create temporary text to measure last line width
				const lastLineText = this.add.rexBBCodeText(0, 0, lastLine, {
					fontFamily: "Space Grotesk",
					fontSize: this.fontSize - 6 * this.scaleFactor,
				})
				const lastLineWidth = lastLineText.width
				lastLineText.destroy()

				// Calculate position for the link
				const lineHeight = tempText.height / Math.max(1, lines.length)
				const linkX = bodyText.x + lastLineWidth

				const isMobile =
					/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
						navigator.userAgent,
					)

				let linkY
				if (!isMobile) {
					linkY = bodyText.y + lineHeight * (lines.length - 1)
				} else {
					linkY =
						bodyText.y + lineHeight * (lines.length - 1) + 4 * this.scaleFactor
				}

				// Clean up temporary text
				tempText.destroy()

				//let newLinkText = linkText + " (safe)"
				let newLinkText = linkText

				// Create a clickable text object for "authentication link"
				const linkTextObj = this.add.text(linkX, linkY, newLinkText, {
					fontFamily: "Space Grotesk",
					fontSize: this.fontSize - 6 * this.scaleFactor,
					color: "#5C58EB",
					fontStyle: "bold",
					resolution: 2,
				})

				displayTooltip(this, {
					xPos: linkX + 50 * this.scaleFactor,
					yPos: linkY + 63 * this.scaleFactor,
					type: "stepBackTip",
					scale: 1,
					text: "Click the link to\nenter the OTP",
					fontScale: -8,
					xTextOffset: 3,
					yTextOffset: 1,
					wrapWidth: 0.8,
				})

				// Add underline
				const underline = this.add.graphics()
				underline.lineStyle(1, 0x5c58eb, 1)
				underline.beginPath()
				underline.moveTo(linkTextObj.x, linkTextObj.y + linkTextObj.height)
				underline.lineTo(
					linkTextObj.x + linkTextObj.width,
					linkTextObj.y + linkTextObj.height,
				)
				underline.closePath()
				underline.strokePath()

				// Make the link interactive
				linkTextObj
					.setInteractive({ useHandCursor: true })
					.on("pointerover", () => {
						linkTextObj.setTint(0x8888ff)
						underline.clear()
						underline.lineStyle(1, 0x8888ff, 1)
						underline.beginPath()
						underline.moveTo(linkTextObj.x, linkTextObj.y + linkTextObj.height)
						underline.lineTo(
							linkTextObj.x + linkTextObj.width,
							linkTextObj.y + linkTextObj.height,
						)
						underline.closePath()
						underline.strokePath()
					})
					.on("pointerout", () => {
						linkTextObj.clearTint()
						underline.clear()
						underline.lineStyle(1, 0x0000ff, 1)
						underline.beginPath()
						underline.moveTo(linkTextObj.x, linkTextObj.y + linkTextObj.height)
						underline.lineTo(
							linkTextObj.x + linkTextObj.width,
							linkTextObj.y + linkTextObj.height,
						)
						underline.closePath()
						underline.strokePath()
					})
					.on("pointerdown", () => {
						console.log("Authentication link clicked!")
						// Redirect to Alerts app
						this.scene.stop("Emails")
						this.scene.start("Alerts")
						playUISound(this, this.soundManager, "Subtle click 1", 0.25)
					})

				// Create mask and scrolling functionality
				this.setupScrollingAndMask(
					bodyText,
					linkTextObj,
					underline,
					scrollStartY,
					scrollHeight,
					scrollEndY,
				)

				// Add elements to email content group
				this.emailContentGroup.add(bodyText)
				this.emailContentGroup.add(linkTextObj)
				this.emailContentGroup.add(underline)
				this.emailContentGroup.add(this.tooltip)
				this.emailContentGroup.add(this.tooltipText)

				this.time.delayedCall(10, () => {
	underline.clear()
	underline.lineStyle(1, 0x0000ff, 1)
	underline.beginPath()
	underline.moveTo(linkTextObj.x, linkTextObj.y + linkTextObj.height)
	underline.lineTo(
		linkTextObj.x + linkTextObj.width,
		linkTextObj.y + linkTextObj.height,
	)
	underline.closePath()
	underline.strokePath()
})
			}
		} else {
			// Regular emails without special links - use BBCodeText
			let bodyText = this.add.rexBBCodeText(
				this.emailBG.x - 230 * this.scaleFactor,
				scrollStartY + 10 * this.scaleFactor,
				email.body,
				{
					fontFamily: "Space Grotesk",
					fontSize: this.fontSize - 4 * this.scaleFactor,
					color: "#11044E",
					align: "left",
					wrap: {
						mode: "word",
						width: 460 * this.scaleFactor,
					},
					lineSpacing: 6,
					resolution: 2,
				},
			)

			// Create mask and scrolling functionality for regular text
			this.setupScrollingAndMaskSingle(
				bodyText,
				scrollStartY,
				scrollHeight,
				scrollEndY,
			)

			this.emailContentGroup.add(bodyText)
		}

		// Add common UI elements to the email content group
		this.emailContentGroup.add(backButton)
		this.emailContentGroup.add(subjectText)
		this.emailContentGroup.add(emailSafetyStatus)
		this.emailContentGroup.add(emailSeparator)

		// Close button (appears on both screens)
		let closeButton = this.add
			.image(
				this.appBar.x + 230 * this.scaleFactor,
				this.appBar.y,
				"appCloseButton",
			)
			.setDepth(10).setScale(this.scaleFactor * 0.5)

		closeButton
			.setInteractive({ useHandCursor: true })
			.on("pointerover", () => closeButton.setTint(0xaaaaaa))
			.on("pointerout", () => closeButton.clearTint())
			.on("pointerdown", () => {
				// Clean up event listeners
				this.input.off("pointerdown")
				this.input.off("pointermove")
				this.input.off("pointerup")

				this.scene.stop("Emails")
				this.scene.resume("TabletScene")

				let tabletScene = this.scene.get("TabletScene")
				if (tabletScene.notificationBell) {
					tabletScene.notificationBell.destroy()
				}
				if (tabletScene.tutorialHand) {
					tabletScene.tutorialHand.destroy()
				}

				tabletScene.removeUnlockAnim()

				playUISound(this, this.soundManager, "Subtle click 1", 0.25)
			})

		this.emailContentGroup.add(closeButton)
	}

	// Helper function for setting up scrolling and masking with links
	setupScrollingAndMask(
		bodyText,
		linkTextObj,
		underline,
		scrollStartY,
		scrollHeight,
		scrollEndY,
	) {
		// Create a mask for both the bodyText and the link text
		const maskShape = this.add
			.rectangle(
				this.emailBG.x - 230 * this.scaleFactor,
				scrollStartY,
				this.emailBG.displayWidth - 20 * this.scaleFactor,
				scrollHeight,
				0xffffff,
			)
			.setVisible(false)

		const maskGraphics = this.make.graphics()
		maskGraphics.fillRectShape(maskShape)

		const geometryMask = new Phaser.Display.Masks.GeometryMask(
			this,
			maskGraphics,
		)

		// Apply mask to all text objects
		bodyText.setMask(geometryMask)
		linkTextObj.setMask(geometryMask)
		underline.setMask(geometryMask)

		// Apply mask to tooltip elements if they exist
		if (this.tooltip && this.tooltip.active) {
			this.tooltip.setMask(geometryMask)
		}
		if (this.tooltipText && this.tooltipText.active) {
			this.tooltipText.setMask(geometryMask)
		}

		// Add scrolling functionality
		const contentHeight = bodyText.height
		const needsScrolling = contentHeight > scrollHeight

		let scrollBar = null
		let scrollThumb = null

		if (needsScrolling) {
			// Create scroll bar background
			const scrollBarWidth = 12 * this.scaleFactor
			const scrollBarX =
				this.emailBG.x + 245 * this.scaleFactor - scrollBarWidth

			scrollBar = this.add.graphics()
			scrollBar.fillStyle(0x888888, 0.6)
			scrollBar.fillRoundedRect(
				scrollBarX,
				scrollStartY,
				scrollBarWidth,
				scrollHeight,
				6 * this.scaleFactor,
			)

			// Create scroll thumb
			const scrollThumbHeight = Math.max(
				20 * this.scaleFactor,
				(scrollHeight / contentHeight) * scrollHeight,
			)

			scrollThumb = this.add.graphics()
			scrollThumb.fillStyle(0x11044e, 0.8)
			scrollThumb.fillRoundedRect(
				scrollBarX + 1 * this.scaleFactor,
				scrollStartY + 1 * this.scaleFactor,
				scrollBarWidth - 2 * this.scaleFactor,
				scrollThumbHeight,
				5 * this.scaleFactor,
			)
			scrollThumb.setInteractive(
				new Phaser.Geom.Rectangle(
					scrollBarX + 1 * this.scaleFactor,
					scrollStartY + 1 * this.scaleFactor,
					scrollBarWidth - 2 * this.scaleFactor,
					scrollThumbHeight,
				),
				Phaser.Geom.Rectangle.Contains,
			)
			scrollThumb.input.cursor = "pointer"

			// Update scroll thumb position based on content position
			const updateScrollThumb = () => {
				if (!scrollThumb) return

				const contentScrollRange = contentHeight - scrollHeight
				const currentScroll = scrollStartY + 10 * this.scaleFactor - bodyText.y
				const scrollPercentage = Math.max(
					0,
					Math.min(1, currentScroll / contentScrollRange),
				)

				const thumbScrollRange = scrollHeight - scrollThumbHeight
				const thumbY =
					scrollStartY +
					1 * this.scaleFactor +
					scrollPercentage * thumbScrollRange

				// Redraw the thumb at new position
				scrollThumb.clear()
				scrollThumb.fillStyle(0x11044e, 0.8)
				scrollThumb.fillRoundedRect(
					scrollBarX + 1 * this.scaleFactor,
					thumbY,
					scrollBarWidth - 2 * this.scaleFactor,
					scrollThumbHeight,
					5 * this.scaleFactor,
				)

				// Update interactive area safely
				if (scrollThumb.input && scrollThumb.input.hitArea) {
					scrollThumb.input.hitArea.y = thumbY
				}
			}

			let isDragging = false
			let isThumbDragging = false
			let dragStartY = 0
			let textStartY = bodyText.y
			let linkStartY = linkTextObj.y
			let tooltipStartY =
				this.tooltip && this.tooltip.active ? this.tooltip.y : 0
			let tooltipTextStartY =
				this.tooltipText && this.tooltipText.active ? this.tooltipText.y : 0
			let thumbDragStartY = 0
			let thumbStartY = scrollThumb.y

			// Scroll thumb drag events
			scrollThumb.on("pointerdown", (pointer) => {
				console.log("Scroll thumb clicked")
				isThumbDragging = true
				thumbDragStartY = pointer.y
				// Get current thumb position from the graphics object
				thumbStartY =
					scrollThumb.input && scrollThumb.input.hitArea
						? scrollThumb.input.hitArea.y
						: scrollThumb.y
				textStartY = bodyText.y
				linkStartY = linkTextObj.y
				tooltipStartY = this.tooltip && this.tooltip.active ? this.tooltip.y : 0
				tooltipTextStartY =
					this.tooltipText && this.tooltipText.active ? this.tooltipText.y : 0
			})

			this.input.on("pointerdown", (pointer) => {
				console.log("Pointer down at: ", pointer.x, pointer.y)
				// Check if clicking on scroll thumb
				if (isThumbDragging) return

				// Check if pointer is in the scroll area
				if (
					pointer.y >= scrollStartY &&
					pointer.y <= scrollEndY &&
					pointer.x >= this.emailBG.x - 230 * this.scaleFactor &&
					pointer.x <= this.emailBG.x + 230 * this.scaleFactor
				) {
					isDragging = true
					dragStartY = pointer.y
					textStartY = bodyText.y
					linkStartY = linkTextObj.y
					tooltipStartY =
						this.tooltip && this.tooltip.active ? this.tooltip.y : 0
					tooltipTextStartY =
						this.tooltipText && this.tooltipText.active ? this.tooltipText.y : 0
				}
			})

			this.input.on("pointermove", (pointer) => {
				console.log("Pointer move at: ", pointer.x, pointer.y)
				if (isThumbDragging) {
					// Handle thumb dragging
					const thumbDragY = pointer.y - thumbDragStartY
					const newThumbY = thumbStartY + thumbDragY

					const thumbScrollRange = scrollHeight - scrollThumbHeight
					const clampedThumbY = Phaser.Math.Clamp(
						newThumbY,
						scrollStartY + 1 * this.scaleFactor,
						scrollStartY + 1 * this.scaleFactor + thumbScrollRange,
					)

					// Calculate content position based on thumb position
					const thumbPercentage =
						(clampedThumbY - scrollStartY - 1 * this.scaleFactor) /
						thumbScrollRange
					const contentScrollRange = contentHeight - scrollHeight + 20 * this.scaleFactor
					const newContentOffset = thumbPercentage * contentScrollRange

					const newBodyY =
						scrollStartY + 10 * this.scaleFactor - newContentOffset
					const newLinkY = linkStartY + (newBodyY - textStartY)

					bodyText.y = newBodyY
					linkTextObj.y = newLinkY

					// Redraw thumb at new position
					scrollThumb.clear()
					scrollThumb.fillStyle(0x11044e, 0.8)
					scrollThumb.fillRoundedRect(
						scrollBarX + 1 * this.scaleFactor,
						clampedThumbY,
						scrollBarWidth - 2 * this.scaleFactor,
						scrollThumbHeight,
						5 * this.scaleFactor,
					)

					// Update interactive area safely
					if (scrollThumb.input && scrollThumb.input.hitArea) {
						scrollThumb.input.hitArea.y = clampedThumbY
					}

					// Move tooltip elements
					if (this.tooltip && this.tooltip.active) {
						this.tooltip.y = tooltipStartY + (newBodyY - textStartY)
					}
					if (this.tooltipText && this.tooltipText.active) {
						this.tooltipText.y = tooltipTextStartY + (newBodyY - textStartY)
					}

					// Update underline position
					underline.clear()
					underline.lineStyle(1, 0x0000ff, 1)
					underline.beginPath()
					underline.moveTo(linkTextObj.x, linkTextObj.y + linkTextObj.height)
					underline.lineTo(
						linkTextObj.x + linkTextObj.width,
						linkTextObj.y + linkTextObj.height,
					)
					underline.closePath()
					underline.strokePath()

					return
				}

				if (!isDragging) return

				// Calculate how far we've dragged
				let dragY = pointer.y - dragStartY

				// Move both text objects together
				let newBodyY = textStartY + dragY
				let newLinkY = linkStartY + dragY

				// Constrain the text position
				const minY =
					scrollStartY - (contentHeight - scrollHeight) - 20 * this.scaleFactor
				const maxY = scrollStartY + 10 * this.scaleFactor

				// Apply constraints
				newBodyY = Phaser.Math.Clamp(newBodyY, minY, maxY)

				// Calculate the difference between constrained and unconstrained positions
				const constraintDiff = newBodyY - (textStartY + dragY)
				newLinkY += constraintDiff

				// Move both texts
				bodyText.y = newBodyY
				linkTextObj.y = newLinkY

				// Move tooltip elements if they exist and are active
				if (this.tooltip && this.tooltip.active) {
					this.tooltip.y = tooltipStartY + dragY + constraintDiff
				}
				if (this.tooltipText && this.tooltipText.active) {
					this.tooltipText.y = tooltipTextStartY + dragY + constraintDiff
				}

				// Update scroll thumb position
				updateScrollThumb()

				// Update underline position
				underline.clear()
				underline.lineStyle(1, 0x0000ff, 1)
				underline.beginPath()
				underline.moveTo(linkTextObj.x, linkTextObj.y + linkTextObj.height)
				underline.lineTo(
					linkTextObj.x + linkTextObj.width,
					linkTextObj.y + linkTextObj.height,
				)
				underline.closePath()
				underline.strokePath()
			})

			this.input.on("pointerup", () => {
				console.log("Pointer up")
				isDragging = false
				isThumbDragging = false
			})

			// Add wheel event for middle mouse scrolling
			this.input.on("wheel", (pointer, gameObjects, deltaX, deltaY, deltaZ) => {
				console.log("Wheel event: ", deltaY)
				// Check if pointer is in the scroll area
				if (
					pointer.y >= scrollStartY &&
					pointer.y <= scrollEndY &&
					pointer.x >= this.emailBG.x - 230 * this.scaleFactor &&
					pointer.x <= this.emailBG.x + 230 * this.scaleFactor
				) {
					// Calculate scroll amount (adjust multiplier as needed for sensitivity)
					const scrollAmount = deltaY * 0.5 * this.scaleFactor

					// Get current positions
					let newBodyY = bodyText.y - scrollAmount
					let newLinkY = linkTextObj.y - scrollAmount

					// Apply constraints
					const minY =
						scrollStartY -
						(contentHeight - scrollHeight) -
						20 * this.scaleFactor
					const maxY = scrollStartY + 10 * this.scaleFactor

					newBodyY = Phaser.Math.Clamp(newBodyY, minY, maxY)
					const constraintDiff = newBodyY - (bodyText.y - scrollAmount)
					newLinkY += constraintDiff

					// Move both texts
					bodyText.y = newBodyY
					linkTextObj.y = newLinkY

					// Move tooltip elements if they exist and are active
					if (this.tooltip && this.tooltip.active) {
						this.tooltip.y -= scrollAmount - constraintDiff
					}
					if (this.tooltipText && this.tooltipText.active) {
						this.tooltipText.y -= scrollAmount - constraintDiff
					}

					// Update scroll thumb position
					updateScrollThumb()

					// Update underline position
					underline.clear()
					underline.lineStyle(1, 0x0000ff, 1)
					underline.beginPath()
					underline.moveTo(linkTextObj.x, linkTextObj.y + linkTextObj.height)
					underline.lineTo(
						linkTextObj.x + linkTextObj.width,
						linkTextObj.y + linkTextObj.height,
					)
					underline.closePath()
					underline.strokePath()
				}
			})

			// Initial scroll thumb position
			updateScrollThumb()
		}

		this.emailContentGroup.add(maskShape)
		if (scrollBar) this.emailContentGroup.add(scrollBar)
		if (scrollThumb) this.emailContentGroup.add(scrollThumb)
	}

	// Helper function for setting up scrolling and masking for single text
	setupScrollingAndMaskSingle(
		bodyText,
		scrollStartY,
		scrollHeight,
		scrollEndY,
	) {
		// Create a mask using a rectangle shape
		const maskShape = this.add
			.rectangle(
				this.emailBG.x - 230 * this.scaleFactor,
				scrollStartY,
				this.emailBG.displayWidth - 20 * this.scaleFactor,
				scrollHeight,
				0xffffff,
			)
			.setVisible(false) // Make the mask invisible

		// Apply the mask directly to the text
		bodyText.setMask(
			new Phaser.Display.Masks.GeometryMask(
				this,
				this.make.graphics().fillRectShape(maskShape),
			),
		)

		// Add scroll functionality
		const contentHeight = bodyText.height
		const needsScrolling = contentHeight > scrollHeight

		let scrollBar = null
		let scrollThumb = null

		if (needsScrolling) {
			// Create scroll bar background with rounded edges
			const scrollBarWidth = 12 * this.scaleFactor
			const scrollBarX =
				this.emailBG.x + 245 * this.scaleFactor - scrollBarWidth

			scrollBar = this.add.graphics()
			scrollBar.fillStyle(0x888888, 0.6)
			scrollBar.fillRoundedRect(
				scrollBarX,
				scrollStartY,
				scrollBarWidth,
				scrollHeight,
				6 * this.scaleFactor,
			)

			// Create scroll thumb with rounded edges
			const scrollThumbHeight = Math.max(
				20 * this.scaleFactor,
				(scrollHeight / contentHeight) * scrollHeight,
			)

			scrollThumb = this.add.graphics()
			scrollThumb.fillStyle(0x11044e, 0.8)
			scrollThumb.fillRoundedRect(
				scrollBarX + 1 * this.scaleFactor,
				scrollStartY + 1 * this.scaleFactor,
				scrollBarWidth - 2 * this.scaleFactor,
				scrollThumbHeight,
				5 * this.scaleFactor,
			)
			scrollThumb.setInteractive(
				new Phaser.Geom.Rectangle(
					scrollBarX + 1 * this.scaleFactor,
					scrollStartY + 1 * this.scaleFactor,
					scrollBarWidth - 2 * this.scaleFactor,
					scrollThumbHeight,
				),
				Phaser.Geom.Rectangle.Contains,
			)
			scrollThumb.input.cursor = "pointer"

			// Update scroll thumb position based on content position
			const updateScrollThumb = () => {
				if (!scrollThumb) return

				const contentScrollRange = contentHeight - scrollHeight
				const currentScroll = scrollStartY + 10 * this.scaleFactor - bodyText.y
				const scrollPercentage = Math.max(
					0,
					Math.min(1, currentScroll / contentScrollRange),
				)

				const thumbScrollRange = scrollHeight - scrollThumbHeight
				const thumbY =
					scrollStartY +
					1 * this.scaleFactor +
					scrollPercentage * thumbScrollRange

				// Redraw the thumb at new position with rounded edges
				scrollThumb.clear()
				scrollThumb.fillStyle(0x11044e, 0.8)
				scrollThumb.fillRoundedRect(
					scrollBarX + 1 * this.scaleFactor,
					thumbY,
					scrollBarWidth - 2 * this.scaleFactor,
					scrollThumbHeight,
					5 * this.scaleFactor,
				)

				// Update interactive area
				scrollThumb.input.hitArea.y = thumbY
			}

			// Create variables to track drag state
			let isDragging = false
			let isThumbDragging = false
			let dragStartY = 0
			let textStartY = 0
			let thumbDragStartY = 0
			let thumbStartY = scrollThumb.y

			// Scroll thumb drag events
			scrollThumb.on("pointerdown", (pointer) => {
				console.log("Scroll thumb clicked")
				isThumbDragging = true
				thumbDragStartY = pointer.y
				// Get current thumb position from the graphics object
				thumbStartY = scrollThumb.input.hitArea.y
				textStartY = bodyText.y
			})

			// Set up drag events
			this.input.on("pointerdown", (pointer) => {
				console.log("Pointer down at: ", pointer.x, pointer.y)
				// Check if clicking on scroll thumb
				if (isThumbDragging) return

				// Check if pointer is in the scroll area
				if (
					pointer.y >= scrollStartY &&
					pointer.y <= scrollEndY &&
					pointer.x >= this.emailBG.x - 230 * this.scaleFactor &&
					pointer.x <= this.emailBG.x + 230 * this.scaleFactor
				) {
					isDragging = true
					dragStartY = pointer.y
					textStartY = bodyText.y
				}
			})

			this.input.on("pointermove", (pointer) => {
				console.log("Pointer move at: ", pointer.x, pointer.y)
				if (isThumbDragging) {
					// Handle thumb dragging
					const thumbDragY = pointer.y - thumbDragStartY
					const newThumbY = thumbStartY + thumbDragY

					const thumbScrollRange = scrollHeight - scrollThumbHeight
					const clampedThumbY = Phaser.Math.Clamp(
						newThumbY,
						scrollStartY + 1 * this.scaleFactor,
						scrollStartY + 1 * this.scaleFactor + thumbScrollRange,
					)

					// Calculate content position based on thumb position
					const thumbPercentage =
						(clampedThumbY - scrollStartY - 1 * this.scaleFactor) /
						thumbScrollRange
					const contentScrollRange = contentHeight - scrollHeight + 20 * this.scaleFactor
					const newContentOffset = thumbPercentage * contentScrollRange

					const newY = scrollStartY + 10 * this.scaleFactor - newContentOffset

					bodyText.y = newY

					// Redraw thumb at new position with rounded edges
					scrollThumb.clear()
					scrollThumb.fillStyle(0x11044e, 0.8)
					scrollThumb.fillRoundedRect(
						scrollBarX + 1 * this.scaleFactor,
						clampedThumbY,
						scrollBarWidth - 2 * this.scaleFactor,
						scrollThumbHeight,
						5 * this.scaleFactor,
					)
					scrollThumb.input.hitArea.y = clampedThumbY

					return
				}

				if (!isDragging) return

				// Calculate how far we've dragged
				let dragY = pointer.y - dragStartY
				let newY = textStartY + dragY

				// Constrain the text position to prevent scrolling beyond content
				const minY =
					scrollStartY - (contentHeight - scrollHeight) - 20 * this.scaleFactor
				const maxY = scrollStartY + 10 * this.scaleFactor

				// Apply constraints
				newY = Phaser.Math.Clamp(newY, minY, maxY)

				// Move the text
				bodyText.y = newY

				// Update scroll thumb position
				updateScrollThumb()
			})

			this.input.on("pointerup", () => {
				console.log("Pointer up")
				isDragging = false
				isThumbDragging = false
			})

			// Add wheel event for middle mouse scrolling
			this.input.on("wheel", (pointer, gameObjects, deltaX, deltaY, deltaZ) => {
				console.log("Wheel event: ", deltaY)
				// Check if pointer is in the scroll area
				if (
					pointer.y >= scrollStartY &&
					pointer.y <= scrollEndY &&
					pointer.x >= this.emailBG.x - 230 * this.scaleFactor &&
					pointer.x <= this.emailBG.x + 230 * this.scaleFactor
				) {
					// Calculate scroll amount (adjust multiplier as needed for sensitivity)
					const scrollAmount = deltaY * 0.5 * this.scaleFactor

					// Get new position
					let newY = bodyText.y - scrollAmount

					// Apply constraints
					const minY =
						scrollStartY -
						(contentHeight - scrollHeight) -
						20 * this.scaleFactor
					const maxY = scrollStartY + 10 * this.scaleFactor

					newY = Phaser.Math.Clamp(newY, minY, maxY)

					// Move the text
					bodyText.y = newY

					// Update scroll thumb position
					updateScrollThumb()
				}
			})

			// Initial scroll thumb position
			updateScrollThumb()
		}

		this.emailContentGroup.add(maskShape)
		if (scrollBar) this.emailContentGroup.add(scrollBar)
		if (scrollThumb) this.emailContentGroup.add(scrollThumb)
	}
}